import { client as apiClient } from '../api/client';
import { AvatarColour, SubscriptionStatus, User } from '../models';

export interface ApiUser {
  color?: AvatarColour;
  email: string;
  first_name?: string;
  last_name?: string;
  premium?: SubscriptionStatus | null;
  premium_ends_at?: string;
}

export class AuthRepository {
  public async login(
    username: string,
    password: string,
    rememberMe: boolean
  ): Promise<void> {
    await apiClient.login(username, password, rememberMe);
  }

  public async getUserData(): Promise<User> {
    const users = await apiClient.get<User, ApiUser>(
      `user/profile`,
      (user: ApiUser) => {
        return new User(
          user.email,
          user.first_name,
          user.last_name,
          user.color,
          user.premium || undefined,
          user.premium_ends_at ? new Date(user.premium_ends_at) : undefined
        );
      }
    );

    return users && users[0];
  }

  public async signUp(
    username: string,
    password: string,
    name: string,
    contactPreference: boolean
  ): Promise<void> {
    await apiClient.signUp(username, password, name, contactPreference);
  }

  public async forgotPassword(email: string): Promise<void> {
    await apiClient.forgotPassword(email);
  }

  public async resetPassword(
    token: string,
    email: string,
    password: string
  ): Promise<void> {
    await apiClient.resetPassword(token, email, password);
  }

  public async logout(ignoreFailure: boolean): Promise<void> {
    await apiClient.logout(ignoreFailure);
  }

  public async updateUser(
    name: string,
    colour: string,
    password?: string,
    currentPassword?: string
  ): Promise<void> {
    await apiClient.updateUser(name, colour, password, currentPassword);
  }
}

let RepositoryClass: ImportedModule<Constructable<AuthRepository>>;
if (process.env.REACT_APP_NO_BACKEND === 'true') {
  RepositoryClass = require('./AuthMock');
} else {
  RepositoryClass = { default: AuthRepository };
}

let repository: AuthRepository;
export default function getRepository() {
  if (!repository) {
    repository = new RepositoryClass.default();
  }

  return repository;
}



// WEBPACK FOOTER //
// ./src/app/repositories/Auth.ts